import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

const EditAction = (props) => {
  const {
    onClick,
    userData,
    label,
    subjectData,
    featureFlag,
    title,
    ariaLabel,
    role,
    small = false,
    disabled,
  } = props;
  const { isAdmin, isCoordinator } = userData;
  const { isPreApSubject } = subjectData;
  const isAdminOrCoordinator = isAdmin || isCoordinator;
  const { icon_preview_update: iconPreviewUpdateFlag } = featureFlag;

  const showIcons = !isPreApSubject && iconPreviewUpdateFlag && !small;
  const _title = typeof title === 'function' ? title(showIcons) : title;
  const _ariaLabel =
    typeof ariaLabel === 'function' ? ariaLabel(showIcons) : ariaLabel;

  return showIcons ? (
    <AccessibilityWrapper>
      <SingleAction
        role={role}
        disabled={isAdminOrCoordinator || disabled}
        tabIndex={0}
        onClick={isAdminOrCoordinator ? null : onClick}
        ariaLabel={_ariaLabel}
        iconName="edit"
        title={_title}
      >
        {label}
      </SingleAction>
    </AccessibilityWrapper>
  ) : (
    <ButtonWithIcon
      isIcon
      isNaked
      icon="edit_question"
      onClick={onClick}
      id="assignment_edit_icon"
      disabled={isAdminOrCoordinator || disabled}
      aria-label={_ariaLabel}
      tabIndex="0"
    />
  );
};

EditAction.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.any,
  title: PropTypes.any,
  ariaLabel: PropTypes.any,
  className: PropTypes.string,
  role: PropTypes.string,
};

EditAction.defaultProps = {
  onClick: () => {},
  label: '',
  title: '',
  ariaLabel: '',
  className: '',
  role: 'button',
};

const mapStateToProps = (state) => {
  const { subject, userData, featureFlag } = state;

  return {
    featureFlag,
    subjectData: subject.data,
    userData,
  };
};

export default connect(mapStateToProps)(EditAction);
